export const names = {
  main: {
    houses: 'houses',
    relatedAddresses: 'relatedAddresses',
    companyId: 'serviceCompanyId',
    name: 'name',
    fromDate: 'fromDate',
    toDate: 'toDate',
    weekends: 'weekends',
    holidays: 'holidays',
    workers: 'workers',
    desks: 'desks',
    notifications: 'notifications',
    addressesForExceptions: 'addressesForExceptions',
    configId: 'graphId',
  },

  desk: {
    name: 'id',
    uniqueDateRange: 'uniqueDateIntervals',
    dateRanges: 'intervalsDates',
    workingDays: 'workingDays',
    isHoliday: 'isHoliday',
    scheduleType: 'graphSetting',
    intervalType: 'intervalsSetting',
    scheduleSettings: 'shedules',
    isCommonSchedules: 'isCommonSchedules',
  },

  deskDateRange: { fromDate: 'fromDate', toDate: 'toDate' },

  deskScheduleSetting: {
    dayType: 'type',
    intervalsPerDay: 'productivity',
    ignoreIntervalsPerDay: 'ingoringProductivity',
    intervals: 'intervals',
    start: 'start',
    end: 'end',
    duration: 'duration',
  },

  scheduleSettingInterval: {
    active: 'active',
    intervalId: 'intervalId',
    mode: 'withExpertInterval',
    availability: 'availability',
    from: 'from',
    to: 'to',
    duration: 'duration',
  },

  notification: {
    type: 'type',
    title: 'title',
    channels: 'channels',
    fromDateTime: 'fromDateTime',
    intervals: 'intervals',
    isCommonMessage: 'isCommonMessage',
    message: 'message',
    proxyMessage: 'proxyMessage',
    intervalMessages: 'intervalMessages',
  },

  notificationIntervalMessage: {
    message: 'message',
    proxyMessage: 'proxyMessage',
  },
};
